import { post, url } from '../../service/ApiDecorator'

class AddressBook {
  // addressBook 获取当前登录角色信息
  @url('/contacts/my')
  @post
  getMyInfo() {}

  // 获取通讯录列表 分页
  @url('/contacts/newlist')
  @post
  getList() {}

  // 通讯录搜索接口
  @url('/contacts/query')
  @post
  query() {}

  // 通讯录组织树结构
  @url('/contacts/tree')
  @post
  getOrgTree() {}

  // 通讯录组织树结构-中查个人详情
  @url('/contacts/userInfo')
  @post
  getUserInfo() {}
  // 根据ids查询名字
  @url('/contacts/queryUserNames')
  @post
  queryUserNames() {}
  // 根据ids查询名字
  @url('/contacts/queryOrgs')
  @post
  queryOrgList() {}
  // 根据组织ids查询名字
  @url('/contacts/queryOrgNames')
  @post
  queryOrgNames() {}

  // 修改个人信息人脸识别照片
  @url('/center/contacts/updateidphoto')
  @post
  updateidphoto() {}

  // 修改当前用户手机号是否可见
  @url('/sys/api/user/updatePhoneShow')
  @post
  updatePhoneShow() {}
  // 获取班级的班主任
  @url('/contacts/queryBzrNames')
  @post
  queryBzrNames() {}
}

export default new AddressBook()
